module.exports = __webpack_public_path__ + "static/img/5.f799106.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/5.png
// module id = MQzM
// module chunks = 0